import { z } from "zod";

export const defaultConfig = {
  countryList: [],
  languageList: [],
  snsList: [],
  linkList: [],
  csInfoType: "pc",
  copyright: "",
  companyLink: "",
};

export const footerConfigSchema = z.object({
  default: z.object({
    countryList: z.array(z.string()),
    languageList: z.array(z.string()),
    snsList: z.array(
      z.object({
        name: z.string(),
        link: z.string(),
      }),
    ),
    linkList: z.array(
      z.object({
        name: z.string(),
        link: z.string(),
        target: z.string(),
        type: z.string(),
        isBold: z.boolean().optional(),
      }),
    ),
    csInfoType: z.string(),
    copyright: z.string(),
    companyLink: z.string(),
  }),
  helpdesk: z
    .object({
      isActive: z.boolean(),
      phone: z.string().optional(),
    })
    .optional(),
});

export type footerConigType = z.infer<typeof footerConfigSchema>;
